import API from './api';

export const fetchAnswers = ({ courseId, lessonId }) =>
  API.get(`/course/${courseId}/lesson/${lessonId}/myAnswers`)
    .then(res => res)
    .catch(err => {
      throw err;
    });

export const postAnswer = ({ courseId, lessonId, answerData }) =>
  API.post(`/course/${courseId}/lesson/${lessonId}/answer`, answerData)
    .then(res => res)
    .catch(err => {
      throw err;
    });

export const updateAnswer = ({ courseId, lessonId, answerId, answerData }) =>
  API.put(
    `/course/${courseId}/lesson/${lessonId}/answer/${answerId}`,
    answerData,
  )
    .then(res => res)
    .catch(err => {
      throw err;
    });

export const deleteAnswer = ({ courseId, lessonId, answerId }) =>
  API.delete(`/course/${courseId}/lesson/${lessonId}/answer/${answerId}`)
    .then(res => res)
    .catch(err => {
      throw err;
    });
